import * as React from 'react'
import { Element } from 'react-scroll'
import { Link } from 'react-router-dom'

interface Props {
}

export default class SeviceComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		const services = [
			{
				image: 'img/ic_service_app_sp.png',
				name: 'iOS/Androidアプリ開発',
				description: 'iOS/Androidアプリともに、開発経験が豊富にあるため、ネイティブおいてもハイブリッドにおいても柔軟な開発が可能です。'
			},
			{
				image: 'img/ic_service_app_web.png',
				name: 'Webアプリ開発',
				description: 'Webアプリにおいても、フロントエンドからサーバーサイドまで、最適かつ最先端の技術で開発が可能です。'
			},
			{
				image: 'img/ic_service_ec.png',
				name: 'EC/メディア開発',
				description: 'ECのパッケージ開発やメディアにおけるCMS構築など、プロダクトに合った技術で柔軟な開発が可能です。'
			},
			{
				image: 'img/ic_service_ui.png',
				name: 'UIデザイン',
				description: 'ペルソナやUXマップ、ユーザーストーリー等を元に、プロトタイピングを繰り返し、ターゲットユーザーに好まれるノンストレスで心地よいUIを定義します。'
			},
			{
				image: 'img/ic_service_ux.png',
				name: 'UXデザイン',
				description: 'ユーザーヒアリングやユーザーテスト等のリサーチやワークショップ、レポーティングを行いながら、仮説を検証・発見し、作るべきUXを定義します。'
			},
			{
				image: 'img/ic_service_growthhack.png',
				name: 'グロースハック',
				description: 'サービス内の解決すべき課題やKPIは何か、ユーザー獲得・定着のためにはどうすれば良いのか、成長を支えるための企画・戦略コンサルティング支援をします。'
			}
		]
		return (
			<Element name="service" className="section" id="service">
				<div className="clear"/>
				<div className="row">
					<div className="container">
						<div className="col-xs-12 col-sm-12 section-title-en">
							SERVICE
						</div>
						<div className="col-xs-12 col-sm-12 section-title-ja">
							ともに、コラボレーティブなサービス開発を。
						</div>
						<div className="col-xs-12 col-sm-12 section-description">
							ユーザーが真に求めているプロダクトやサービスを実現するためには、「コラボレーション」は必要不可欠です。それは単に作業効率を上げるという目的ではなく、メンバーで知恵を分け合い、アイディアの実現を現実的なものへと近づけていくためです。
						</div>
						{services.map((service, i) => {
							return (
								<div key={i} className="col-xs-12 col-sm-4 service-cell">
									<div className="service-image">
										<img src={service.image} />
									</div>
									<div className="service-name">
										{service.name}
									</div>
									<div className="service-description">
										{service.description}
									</div>
								</div>
							)
						})}
						<div className="col-xs-12 col-sm-12 conversion">
							<Link to="/contacts" className="conversion-button">相談してみる（無料）</Link>
						</div>
					</div>
				</div>
			</Element>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/welcome/components/serviceComponent.tsx